import {useContext} from "react";
import {
	DevCycleUser,
	useDevCycleClient,
	useIsDevCycleInitialized,
	useVariableValue
} from "@devcycle/react-client-sdk";
import {AuthContext} from "@buildwitt/shapeshift-identity";
import {IUser} from "@buildwitt/shapeshift-types";

type EnrichedUser = IUser & {organizationId?: string, externalId?: string}

const useDevCycleSdk = () => ({
	topMenuUpdate: useVariableValue("top-menu-update", false),
	plumeMayDelivery: useVariableValue("plume-may-delivery", false),
	playlists: useVariableValue("playlist", false),
	announcements: useVariableValue("announcements", false),
	archiveUserFlow: useVariableValue("archive-user-flow", true),
	contentCreationUpdates: useVariableValue("content-creation-updates", false),
	hideCreationButtons: useVariableValue("hide-creation-buttons", true),
	filterSettingsPersistence: useVariableValue("filter-settings-persistence", false),
	teamProgress: useVariableValue("team-progress", false),
	trainingPool: useVariableValue("training-pool", false),
	disableAutoAssign: useVariableValue("disable-auto-assign", false),
	meiliSearchIntegration: useVariableValue("meili-search-integration", false),
	bulkRescheduleOverdue: useVariableValue("bulk-reschedule-overdue", false),
	improvedSteaksAndCompletions: useVariableValue("improved-steaks-and-completions", false),
	courseBulkEnrollment: useVariableValue("course-bulk-enrollment", false),
	playlistBasedCerts: useVariableValue("playlist-based-certs", false),
	dueDateAssignments: useVariableValue("due-date-assignments", false),
	monthEndReport: useVariableValue("month-end-report", false),
	pauseStreak: useVariableValue("pause-streak", false),
	lessonLinksAttachments: useVariableValue("lesson-links-attachments", false),
	newHomeScreen: useVariableValue("new-home-screen", false)
});

export const useDevCycleIdentifier = (): void => {
	const devCycleClient = useDevCycleClient();
	const isDevCycleInitialized = useIsDevCycleInitialized();
	const {user} = useContext(AuthContext);

	if (!user || isDevCycleInitialized) return;

	const enrichedUser: EnrichedUser = user;
	const devCycleUser: DevCycleUser = {
		user_id: enrichedUser.externalId ?? "unidentified-user",
		isAnonymous: false,
		email: enrichedUser.email ?? "",
		customData: {
			orgId: enrichedUser.organizationId ?? ""
		}
	};

	devCycleClient.identifyUser(devCycleUser, error => {
		if (error) console.error("devCycleClient.identifyUser", error);
	});
};

export default useDevCycleSdk;
